import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import styles from './Loading.css';

const Loading = ({ size, color, primaryColor, style, className }) => (<div
    className={cx(
        styles.container,
        className,
    )}
    style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
    }}
    aria-label="Loading"
    role="alert"
    aria-busy="true"
    aria-live="assertive"
>
    <div className={cx(styles.cube, styles.cube1)}>
        <div
            className={styles.fill}
            style={{
                backgroundColor: (color || primaryColor),
            }}
        />
    </div>
    <div className={cx(styles.cube, styles.cube2)}>
        <div
            className={styles.fill}
            style={{
                backgroundColor: (color || primaryColor),
            }}
        />
    </div>
    <div className={cx(styles.cube, styles.cube3)}>
        <div
            className={styles.fill}
            style={{
                backgroundColor: (color || primaryColor),
            }}
        />
    </div>
    <div className={cx(styles.cube, styles.cube4)}>
        <div
            className={styles.fill}
            style={{
                backgroundColor: (color || primaryColor),
            }}
        />
    </div>
</div>);

Loading.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    style: PropTypes.object,
    primaryColor: PropTypes.string,
    className: PropTypes.string,
};

Loading.defaultProps = {
    style: {},
    size: 10,
};

export default connect(({ theme }) => ({
    primaryColor: theme.primaryColor,
}))(Loading);



// WEBPACK FOOTER //
// ./src/client/Components/Loading/Loading.js